import { render } from "./UserDevicesData.vue?vue&type=template&id=f2f71036"
import script from "./UserDevicesData.vue?vue&type=script&lang=js"
export * from "./UserDevicesData.vue?vue&type=script&lang=js"

import "@/styles/profile/users/userReferalsData.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__